'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _validateProfile = require('./modules/validateProfile');

var _RuleFieldShape = require('./RuleFieldShape');

var _RuleFieldShape2 = _interopRequireDefault(_RuleFieldShape);

var _ProfileFieldShape = require('./ProfileFieldShape');

var _ProfileFieldShape2 = _interopRequireDefault(_ProfileFieldShape);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ProfileField = function (_Component) {
  _inherits(ProfileField, _Component);

  function ProfileField() {
    var _temp, _this, _ret;

    _classCallCheck(this, ProfileField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleChange = function (e) {
      var _onFieldUpdate;

      var _this$props = _this.props,
          field = _this$props.field,
          data = _this$props.data,
          onFieldUpdate = _this$props.onFieldUpdate;
      var value = e.target.value;
      var error = data.touched ? (0, _validateProfile.applyValidation)(field, value) : null;
      var maskedValue = (0, _validateProfile.applyMask)(field, value);
      onFieldUpdate((_onFieldUpdate = {}, _onFieldUpdate[field.name] = _extends({}, data, {
        value: maskedValue,
        error: error
      }), _onFieldUpdate));
    }, _this.handleBlur = function () {
      var _onFieldUpdate2;

      var _this$props2 = _this.props,
          field = _this$props2.field,
          data = _this$props2.data,
          onFieldUpdate = _this$props2.onFieldUpdate;
      var error = (0, _validateProfile.applyValidation)(field, data.value);
      onFieldUpdate((_onFieldUpdate2 = {}, _onFieldUpdate2[field.name] = _extends({}, data, {
        touched: true,
        error: error
      }), _onFieldUpdate2));
    }, _this.inputRef = function (el) {
      _this.el = el;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ProfileField.prototype.componentDidUpdate = function componentDidUpdate() {
    var _props = this.props,
        field = _props.field,
        data = _props.data,
        onFieldUpdate = _props.onFieldUpdate;

    if (data.focus && this.el) {
      var _onFieldUpdate3;

      this.el.focus();
      onFieldUpdate((_onFieldUpdate3 = {}, _onFieldUpdate3[field.name] = _extends({}, data, {
        focus: false
      }), _onFieldUpdate3));
    }
  };

  ProfileField.prototype.render = function render() {
    var _props2 = this.props,
        field = _props2.field,
        data = _props2.data,
        options = _props2.options,
        Input = _props2.Input;
    return _react2.default.createElement(Input, {
      field: field,
      data: data,
      options: options,
      inputRef: this.inputRef,
      onChange: this.handleChange,
      onBlur: this.handleBlur
    });
  };

  return ProfileField;
}(_react.Component);

ProfileField.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Rules for the field this component represents */
  field: _RuleFieldShape2.default.isRequired,

  /** Data to be displayed by this component */
  data: _ProfileFieldShape2.default.isRequired,

  /** Additional options to modify this input */
  options: _propTypes2.default.object,

  /** Function to be called when data changes */
  onFieldUpdate: _propTypes2.default.func.isRequired,

  /** Component to be used as input for the field */
  Input: _propTypes2.default.func.isRequired
} : {};
exports.default = ProfileField;
module.exports = exports['default'];